import React from 'react';
import './Stats.css';

const Stats = () => {
  return (
    <section className="stats">
      <div className="stats-background">
        <div className="stats-overlay"></div>
      </div>
      
      <div className="container">
        {/* Stats content has been removed */}
      </div>
    </section>
  );
};

export default Stats;
